"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useAppDataSchemaInstances(query) {
  const { ...rest } = useElements(
    "app-data-schema-instances",
    query
  );
  return {
    appDataSchemaInstances: rest.items,
    ...rest
  };
}

export { useAppDataSchemaInstances };
